export default [
  {
    path: '/dashboard/ecommerce',
    name: 'dashboard-ecommerce',
    component: () => import('@/views/dashboard/ecommerce/Ecommerce.vue'),
    meta: { resource: 'Dashboard', action: 'Dashboard' },
  },
  {
    path: '/dashboard/ecommerce/analytics',
    name: 'dashboard-ecommerce-analytics',
    component: () => import('@/views/dashboard/ecommerce/AnalyticsIndex.vue'),
    meta: { resource: 'Admin', action: 'Admin' },
  },
  {
    path: '/dashboard/ecommerce/smartReport',
    name: 'dashboard-ecommerce-smartReport',
    component: () => import('@/views/dashboard/ecommerce/smartReport.vue'),
    meta: { resource: 'Admin', action: 'Admin' },
  },
]
